var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "stars-input" },
    [
      _c("input-group-head", {
        class: ["stars-input__head", { large: _vm.large }],
        attrs: { label: _vm.label, error: _vm.error, large: _vm.large }
      }),
      _c(
        "div",
        {
          class: [
            "stars-input__inner-wrap",
            { "value-labels": _vm.labelLeft || _vm.labelLeft }
          ]
        },
        [
          _vm.labelLeft
            ? _c("div", { staticClass: "stars-input__label" }, [
                _vm._v("\n      " + _vm._s(_vm.labelLeft) + "\n    ")
              ])
            : _vm._e(),
          _c("stars-rating", {
            staticClass: "stars-input__input",
            attrs: {
              size: _vm.sizeStars,
              value: _vm.value,
              "error-mode": !!_vm.error,
              interactive: ""
            },
            on: { input: _vm.onInput }
          }),
          _vm.labelRight
            ? _c("div", { staticClass: "stars-input__label" }, [
                _vm._v("\n      " + _vm._s(_vm.labelRight) + "\n    ")
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }